import Vue from 'vue'

window.Vue = Vue

const baseUrl = process.env.WEB_BASE_URL
const href = baseUrl + '/js/desktop/daiso-ui-desktop.css'

if (!document.querySelector(`link[href="${href}"]`)) {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = process.env.VUE_APP_ENV !== 'loc' ? href : require('@daiso/ui/dist/desktop/daiso-ui-desktop.css')
  document.head.appendChild(link)
}

if (process.env.VUE_APP_ENV !== 'loc') {
  loadScript(baseUrl + '/js/desktop/daiso-ui-desktop.umd.js').then(() => {
    console.log('DaisoUI loaded via UMD and auto-installed.')
  }).catch((err) => {
    console.error('Failed to load DaisoUI:', err)
  })
} else {
  const DaisoUI = require('@daiso/ui/dist/desktop/daiso-ui-desktop.common').default
  Vue.use(DaisoUI)
}

function loadScript (src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      return resolve()
    }
    const script = document.createElement('script')
    script.src = src
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Failed to load DaisoUI: ${src}`))
    document.head.appendChild(script)
  })
}
